export default __webpack_public_path__ + "static/media/6.4e2148f6.jpg";